<div class="phx-date-picker-body-day-wrapper">
  <span *ngFor="let day of daysName" class="phx-date-picker-body-day-cell">
    {{ day }}
  </span>
</div>

<div class="phx-date-picker-body-date-wrapper">
  <span
    *ngFor="let date of allDaysOfMonth | keyvalue"
    phxFocusableItem
    phx-tooltip
    phxTooltipSize="small"
    [phxPlacement]="tooltipPlacement"
    [phxContent]="date.value.tooltipText"
    ngClass="phx-date-picker-body-date-cell-{{ date.value.status }} {{
      resolveHoverClass(date.key)
    }}"
    (click)="!date.value.isDisabled && dateSelected(date.value.date)"
    (mouseenter)="onDateHover(date.value.date)"
    (keyup)="onKeyup(date.value, $event)"
    (keydown)="onKeydown(date.value, $event)"
    [skip]="date.value.isDisabled"
  >
    {{ date.value.day }}
    <i
      *ngIf="date.value.hasEvent && !date.value.isDisabled"
      phx-icon
      [phxIcon]="DotFilledIcon"
      [size]="eventIconSize"
      [color]="eventColor"
    ></i>
  <div class="phx-date-event-container">
    <span *ngFor="let event of date.value.events" class="phx-date-event-box-small" [style.background]="getEventColorByName(event)"></span>
  </div>
  </span>
</div>
<div *ngIf="eventColorMap.size > 0" class="phx-date-event-name-container">
  <div *ngFor="let item of eventColorMap | keyvalue"  class="phx-date-event-name-box">
    <span class="phx-date-event-box-large" [style.background]="getEventColorByName(item.key)"></span>
    <p class="phx-event-name phx-web-type-body-extra-small">{{ item.key }}</p>
  </div>
</div>